import { MutableRefObject, useEffect, useRef } from 'react';

/**
 * Provides execution of callback function on mousemove with relation to particular element
 * If element, mouse moved on, match stored in 'ref' - call callback with 'true' parameters, otherwise - with 'false.
 * In case 'ref' is not passed - use current ref (ref of currently rendered component)
 * @param callBack
 * @param ref
 */
function useHover(
    callBack: (isClickOnRef: boolean, event: MouseEvent) => void,
    ref?: MutableRefObject<HTMLElement>,
    ) {
    const componentRef = ref || useRef(null);

    useEffect(() => {
        function handleMouseMove(event: MouseEvent) {
            if (!componentRef.current || !componentRef.current.contains(event.target)) {
                // mouse is moved over the element, other than referenced one (or referenced one is not exists)
                callBack(false, event);
            } else {
                // mouse is moved over the referenced element
                callBack(true, event);
            }
        }

        document.addEventListener('mousemove', handleMouseMove);

        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousemove', handleMouseMove);
        };
    }, [componentRef, callBack]);
    return componentRef;
}

export { useHover };